export function checkVisibility(el) {
    if (!el)
        return false;
    return (el.getBoundingClientRect().width !== 0 &&
        el.getBoundingClientRect().height !== 0 &&
        window.getComputedStyle(el).visibility === 'visible' &&
        window.getComputedStyle(el).opacity !== '0');
}
